

export function refererDomain(){
  var matches = String(window.RefererApi.getActiveReferer()).match(/(?:http|https):\/\/([^/]+)(?:.+)/i);

  if(matches){
    return matches[1]
  }
  return null;
}


export function refererURL(){
  return String(window.RefererApi.getActiveReferer());
}
